import axios from 'axios';
import lodash from 'lodash';

export const changeObjectKeys = (data, handler = lodash.camelCase) => {
    if (data === null || data === undefined) {
        return null;
    }

    if (Array.isArray(data)) {
        return data.map(item => changeObjectKeys(item, handler));
    }

    if (typeof data === 'object') {
        return Object.keys(data).reduce((result, key) => {
            return {
                ...result,
                [handler(key)]: changeObjectKeys(data[key])
            };
        }, {});
    }

    return data;
};

export const query = async (url,
                            {
                                baseUrl = '/api/v2',
                                params = {},
                                headers = {},
                                json = null,
                                data = null,
                                formData = null,
                                config: _config = {}
                            }
) => {
    const config = {
        url: baseUrl + url,
        method: 'get',
        params: changeObjectKeys(params, lodash.snakeCase),
        headers: {
            ...headers,
            Accept: 'application/json',
        },
        ..._config,
    };

    if (json) {
        config.headers['Content-Type'] = 'application/json';
        config.data = changeObjectKeys(json, lodash.snakeCase);
        config.method = 'post';
    }

    if (data) {
        config.headers['Content-Type'] = 'multipart/form-data';
        const newData = changeObjectKeys(data, lodash.snakeCase);
        const newForm = new FormData();

        // eslint-disable-next-line guard-for-in
        for (const key in newData) {
            newForm.append(key, newData[key]);
        }
        config.data = newForm;
        config.method = 'post';
    }

    if (formData) {
        config.headers['Content-Type'] = 'multipart/form-data';
        config.data = formData;
        config.method = 'post';
    }

    try {
        const response = await axios(config);
        if (typeof response.data === 'string') {
            return response.data;
        }

        return {
            isSuccess: true,
            ...changeObjectKeys(response.data)
        };
    } catch (error) {
        return {
            isSuccess: false,
            ...changeObjectKeys(error.response.data)
        };
    }
};

